/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const SpannerBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5.857 2.933a5.5 5.5 0 0 1 7.501 6.31l7.672 7.666a1.25 1.25 0 0 1 0 1.768l-2.353 2.353a1.25 1.25 0 0 1-1.768 0l-7.665-7.671a5.5 5.5 0 0 1-6.31-7.501c.365-.865 1.436-.964 2.014-.386l2.114 2.114.524-.524-2.114-2.114c-.578-.578-.48-1.649.385-2.015Zm1.998 1.57L9.53 6.178a1.25 1.25 0 0 1 0 1.768L7.946 9.53a1.25 1.25 0 0 1-1.768 0L4.503 7.855a3.5 3.5 0 0 0 4.689 3.437l.598-.216 8.003 8.01 1.293-1.293-8.01-8.003.216-.598a3.5 3.5 0 0 0-3.437-4.689Z" /></svg>);
const Spanner = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={SpannerBase} {...rest} ref={ref} />);
export default Spanner;